import { render, staticRenderFns } from "./channelOptions.vue?vue&type=template&id=40c7b0f0&scoped=true&"
import script from "./channelOptions.vue?vue&type=script&lang=js&"
export * from "./channelOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c7b0f0",
  null
  
)

export default component.exports